export const ROLES = {
    NUTRITIONIST:"nutritionist",
    ADMIN:"admin",
    APP_USER:"user"
}